module.exports = __webpack_public_path__ + "static/media/Evie-Frawley.60d7a159.jpg";